import { OrderTableEnum } from '../enums/orderTableEnum';

export const mensagem = `Houve uma falha na conexão com o servidor, por favor tente novamente ou mais tarde.`;

export const schoolType = [
  { id: 1, name: 'own', description: 'Própria' },
  { id: 2, name: 'partner', description: 'Parceira' },
  { id: 3, name: 'prospect', description: 'Prospect' },
  { id: 4, name: 'training', description: 'Treinamento'},
  { id: 5, name: 'resale', description: 'Revenda' },
  { id: 6, name: 'tasting', description: 'Degustação' },
  { id: 7, name: 'contest', description: 'Concurso' },
  { id: 8, name: 'cancellation', description: 'Distrato' },
  { id: 9, name: 'franchise', description: 'Franquia' },
  { id: 10, name: 'fictional', description: 'Fictícia' }
];

export const estateData = [
  { id: 1, description:  'Acre', initials: 'AC'},
  { id: 2, description:  'Alagoas', initials: 'AL' },
  { id: 3, description:  'Amapá', initials: 'AP'},
  { id: 4, description:  'Amazonas', initials: 'AM' },
  { id: 5, description:  'Bahia', initials: 'BA' },
  { id: 6, description:  'Ceará', initials: 'CE' },
  { id: 7, description:  'Distrito Federal', initials: 'DF'},
  { id: 8, description:  'Espirito Santo', initials: 'ES' },
  { id: 9, description:  'Goiás', initials: 'GO' },
  { id: 10, description: 'Maranhão', initials: 'MA' },
  { id: 11, description: 'Mato Grosso', initials: 'MT'},
  { id: 12, description: 'Mato Grosso do Sul', initials: 'MS' },
  { id: 13, description: 'Minas Gerais', initials: 'MG' },
  { id: 14, description: 'Pará', initials: 'PA' },
  { id: 15, description: 'Paraíba', initials: 'PB' },
  { id: 16, description: 'Paraná', initials: 'PR' },
  { id: 17, description: 'Pernambuco', initials: 'PE' },
  { id: 18, description: 'Piauí', initials: 'PI' },
  { id: 19, description: 'Rio de Janeiro', initials: 'RJ' },
  { id: 20, description: 'Rio Grande do Norte', initials: 'RN' },
  { id: 21, description: 'Rio Grande do Sul', initials: 'RS' },
  { id: 22, description: 'Rondônia', initials: 'RO' },
  { id: 23, description: 'Roraima', initials: 'RR' },
  { id: 24, description: 'Santa Catarina', initials: 'SC' },
  { id: 25, description: 'São Paulo', initials: 'SP' },
  { id: 26, description: 'Sergipe', initials: 'SE' },
  { id: 27, description: 'Tocantins', initials: 'TO' },
];

export const schoolFieldFilterEnum  =  [
  { label: 'Grupo', id: 0 , order: OrderTableEnum.NotOrder, field: 'TenantName' },
  { label: 'ID', id: 1, order: 2, field: 'ReferenceId' },
  { label: 'CNPJ', id: 2, order: OrderTableEnum.NotOrder, field: 'DocumentCNPJ' },
  { label: 'Nome Fantasia', id: 3, order: OrderTableEnum.NotOrder, field: 'FantasyName' },
  { label: 'Tipo', id: 4, order: OrderTableEnum.NotOrder, field: 'SchoolType' },
  { label: 'Email', id: 5, order: OrderTableEnum.NotOrder, field: '' },
  { label: 'Telefone', id: 6, order: OrderTableEnum.NotOrder, field: '' },
  { label: 'Ações', id: 7, order: OrderTableEnum.NotOrder, field: '' } ];

